export default __webpack_public_path__ + "static/media/hypercard.65d6d089.png";